export class StudentEnrollmentType {
  public static Registered: string = "Registered";
  public static Withdrawn: string = "Withdrawn";
  public static Graduated: string = "Graduated";
}
